import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: any) => ({
  dataAggregation: {
    display: 'flex'
  },
  leftPanel: {
    width:'50%'
  },
  rightPanel: {
    width:'50%'
  },
  modalChip: {
    padding: '8px'
  },
  overlay: {
    background: '#e9e9e9',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    opacity: 0.5,
    zIndex: 998
  },
  loader: {
    position: 'absolute',
    border: '4px solid #f3f3f3',
    borderRadius: '50%',
    borderTop: '4px solid #eb0a1e',
    borderBottom: '4px solid #eb0a1e',
    borderLeft: '4px solid #eb0a1e',
    width: '120px',
    height: '120px',
    top: '50%',
    left: '40%',
    transform: `translate(-50%, -50%)`,
    webkitAnimation: '$spin 2s linear infinite',
    animation: '$spin 2s linear infinite'
  },


  "@-webkit-keyframes spin": {
    '0%': { "-webkit-transform": 'rotate(0deg)' },
    '100%': { "-webkit-transform": 'rotate(360deg)' }
  },


  "@keyframes spin": {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' }
  },
}));